import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';


export const UserBar = () => {
    const location = useLocation();

    if (['customers'].some(v => location.pathname.includes(v))) {
        return (
            <div className="userbar">
                <Link to="/customers/new"><div className="userbar__button"></div></Link>
            </div>
        );
    }
    if (['subscriptions'].some(v => location.pathname.includes(v))) {
        return (
            <div className="userbar">
                <Link to="/subscriptions/new"><div className="userbar__button"></div></Link>
            </div>
        );
    }
    if (['payments'].some(v => location.pathname.includes(v))) {
        return (
            <div className="userbar">
                <Link to="/payments/new"><div className="userbar__button"></div></Link>
            </div>
        );
    }
    return null;
};
